import React, { FC, ReactElement, ReactNode } from 'react'

import { FontSize } from 'common-constants/sizes'
import { SmallNoteText } from 'components/block/PhotoLine/PhotoLineTooltip.styled'
import { FavoritesSvgContainer } from 'components/page/ContactList/Item/ContactContent'
import {
  ImageContentWrapper,
  ImageIconWrapper,
  ImageWrapper,
} from 'components/page/ProfileGiftsModal/ProfileGiftsModal.styled'

import { ProfileName } from '../ProfileName/ProfileName'

/**
 * Слишком много всего передается в компонент.
 * Нужно вынести связанное с заголовком пользователя.
 * Частично сделал в рамках поля title.
 */
export const ProfileInfo: FC<{
  icon?: ReactElement
  iconSize?: number
  name?: string
  locationShow?: boolean
  age?: number | null
  online?: boolean | null
  verifiedPhotos?: boolean | null
  locationName?: string
  message?: ReactElement
  systemMessage?: ReactElement | boolean
  favourite?: ReactElement
  countMessage?: ReactElement | null
  buttonRemoveGift?: ReactElement | boolean
  fontSize?: number
  fontSizeLocation?: number
  title?: ReactNode
  alignItems?: 'flex-start' | 'center' | 'flex-end'
}> = ({
  icon,
  iconSize = 60,
  name,
  age,
  online,
  locationShow,
  verifiedPhotos,
  locationName,
  message,
  systemMessage,
  favourite,
  countMessage,
  buttonRemoveGift,
  fontSizeLocation = FontSize.note,
  alignItems = 'flex-start',
  title = (
    <ProfileName
      fullName={name!}
      age={age}
      online={online!}
      statusVerification={verifiedPhotos!}
    />
  ),
}) => {
  return (
    <ImageWrapper $alignItems={alignItems}>
      <ImageIconWrapper $size={iconSize}>{icon}</ImageIconWrapper>
      <ImageContentWrapper>
        {title}
        {locationName && locationShow && (
          <SmallNoteText fontSize={fontSizeLocation}>
            {locationName}
          </SmallNoteText>
        )}
        {message}
        {buttonRemoveGift}
        {systemMessage}
        <FavoritesSvgContainer>
          {favourite}
          {countMessage}
        </FavoritesSvgContainer>
      </ImageContentWrapper>
    </ImageWrapper>
  )
}
